import React from 'react';
import classes from '../styles.module.scss';
import { createCn } from '../../../helpers/utils';
import type { ChartBarItem } from '../utils/video-insights-utils';

const cn = createCn('file', classes);

type Props = {
  title: string;
  items: ChartBarItem[];
};

const VideoInsightsBarChart = ({ title, items }: Props) => {
  const maxAbs = Math.max(...items.map(i => Math.abs(i.value)), 1);

  return (
    <div className={cn('vi-bar-chart')} aria-label={title}>
      <p className={cn('vi-bar-chart-title')}>{title}</p>
      <ul className={cn('vi-bar-chart-list')}>
        {items.map(item => {
          const widthPct = Math.max(4, (Math.abs(item.value) / maxAbs) * 100);
          return (
            <li key={item.label} className={cn('vi-bar-chart-row')}>
              <span className={cn('vi-bar-chart-label')} title={item.label}>
                {item.label}
              </span>
              <span className={cn('vi-bar-chart-track')}>
                <span
                  className={cn('vi-bar-chart-fill', { [item.tone]: true })}
                  style={{ width: `${widthPct}%` }}
                />
              </span>
              <span className={cn('vi-bar-chart-value', { [item.tone]: true })}>
                {item.displayValue}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default VideoInsightsBarChart;
